import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/modules/authentication'
import estados from '@/modules/estados'


import reservas from '@/modules/reservas'
import clientes from '@/modules/clientes'

import reportes from '@/modules/reportes'
import mensajes from '@/modules/mensajes'

import categorias from '@/modules/categorias'
import caminos from '@/modules/caminos'
import puntos from '@/modules/puntos' 
import proveedores from '@/modules/proveedores' 
import etapas from '@/modules/etapas' 
import origenes from '@/modules/origenes' 
import grupos from '@/modules/grupos' 
import reglas from '@/modules/reglas'
import inventario from '@/modules/inventario'
import apicorreos from '@/modules/apicorreos'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    dark: true,
    pantallaActiva: null,
    drawer: false,
    // Tema Azul-Amarillo
    colorAmarillo1: '#F9F6CD',
    colorAmarillo2: '#D5D397',
    colorAmarillo3: '#B2AF60',
    
    colorAceituna1: '#BAD1C1',
    colorAceituna2: '#8BA393',
    colorAceituna3: '#5A7564',

    colorVerde1: '#4FA195',
    colorVerde2: '#2B9D8B',
    colorVerde3: '#0A9A80',

    colorAzul1: '#2C6BB5',
    colorAzul2: '#21508C',
    colorAzul3: '#143461',

    colorGrisClaro: '#D4D6D9',

    // Tema VerdeOpaco-Mostaza
    colorBlanco: '#FFFFFF',
    colorMostazaOscuro: '#C99C33',
    colorMostazaClaro: '#D6A217',
    colorAzul: '#1890B3',
    colorTurquesa: '#18B3A7',
    colorVerdeOpacoOscuro: '#3D5654',
    colorVerdeOpacoClaro: '#425C5A',
    colorFondoOscuro: '#CADFDE',
    colorFondoClaro: '#E3F2F1',

    colorFondo: null,
    colorFondoDialog: null,
    colorNavigationMenu: null,
    colorBarraFormulario: null,
    colorBarraFormularioSecundario: null,
    colorAccent1: null,
    colorAccent2: null,
    colorAccent3: null,

    provincias: [
      'Álava', 'Albacete', 'Alicante', 'Almería', 'Asturias', 'Ávila', 'Badajoz', 'Barcelona', 'Burgos', 'Cáceres',
      'Cádiz', 'Cantabria', 'Castellón', 'Ciudad Real', 'Córdoba', 'Cuenca', 'Gerona', 'Granada', 'Guadalajara',
      'Guipúzcoa', 'Huelva', 'Huesca', 'Islas Baleares', 'Jaén', 'A Coruña', 'La Rioja', 'Las Palmas', 'León',
      'Lérida', 'Lugo', 'Madrid', 'Málaga', 'Murcia', 'Navarra', 'Orense', 'Palencia', 'Pontevedra', 'Salamanca',
      'Santa Cruz de Tenerife', 'Segovia', 'Sevilla', 'Soria', 'Tarragona', 'Teruel', 'Toledo', 'Valencia',
      'Valladolid', 'Vizcaya', 'Zamora', 'Zaragoza'
    ].sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' })).concat([
      'Açores', 'Aveiro', 'Beja', 'Braga', 'Bragança', 'Castelo Branco', 'Coimbra', 'Évora', 'Faro', 'Guarda',
      'Leiria', 'Lisboa', 'Madeira', 'Portalegre', 'Porto', 'Santarém', 'Setúbal', 'Viana do Castelo', 'Vila Real', 'Viseu'
    ]),

    dificultades: ['Fácil', 'Fácil/Media', 'Media', 'Media/Difícil', 'Difícil'],
    tiposProveedor: ['Albergue', 'Camping', 'Hotel', 'Hostal', 'Pensión', 'Refugio', 'Otro'],
    tiposCliente: ['Particular', 'Empresa', 'ProfesionalAutonomo', 'NoDefinido'],

    nacionalidades: [
      'Afganistán',
      'Albania',
      'Alemania',
      'Andorra',
      'Angola',
      'Antigua y Barbuda',
      'Arabia Saudita',
      'Argelia',
      'Argentina',
      'Armenia',
      'Australia',
      'Austria',
      'Azerbaiyán',
      'Bahamas',
      'Bahréin',
      'Bangladés',
      'Barbados',
      'Bélgica',
      'Belice',
      'Benín',
      'Bielorrusia',
      'Birmania',
      'Bolivia',
      'Bosnia y Herzegovina',
      'Botsuana',
      'Brasil',
      'Brunéi',
      'Bulgaria',
      'Burkina Faso',
      'Burundi',
      'Cabo Verde',
      'Camerún',
      'Canadá',
      'Chad',
      'Chile',
      'China',
      'Chipre',
      'Colombia',
      'Comoras',
      'Congo',
      'Corea del Norte',
      'Corea del Sur',
      'Costa Rica',
      'Croacia',
      'Cuba',
      'Dinamarca',
      'Dominica',
      'Ecuador',
      'Egipto',
      'El Salvador',
      'Emiratos Árabes Unidos',
      'Eslovenia',
      'España',
      'Estados Unidos',
      'Estonia',
      'Eswatini',
      'Etiopía',
      'Filipinas',
      'Finlandia',
      'Francia',
      'Gambia',
      'Georgia',
      'Ghana',
      'Grecia',
      'Granada',
      'Guatemala',
      'Guinea',
      'Guinea-Bisáu',
      'Guyana',
      'Haití',
      'Honduras',
      'Hungría',
      'India',
      'Indonesia',
      'Irán',
      'Iraq',
      'Irlanda',
      'Islacia',
      'Islas Marshall',
      'Islas Salomón',
      'Italia',
      'Jamaica',
      'Japón',
      'Jordania',
      'Kazajistán',
      'Kenia',
      'Kirguistán',
      'Kiribati',
      'Kuwait',
      'Laos',
      'Lesoto',
      'Letonia',
      'Líbano',
      'Liberia',
      'Libia',
      'Liechtenstein',
      'Lituania',
      'Luxemburgo',
      'Madagascar',
      'Malasia',
      'Malawi',
      'Maldivas',
      'Mali',
      'Malta',
      'Marruecos',
      'Mauricio',
      'Mauritania',
      'México',
      'Micronesia',
      'Mónaco',
      'Mongolia',
      'Mozambique',
      'Namibia',
      'Nauru',
      'Nepal',
      'Nicaragua',
      'Níger',
      'Nigeria',
      'Noruega',
      'Nueva Zelanda',
      'Omán',
      'Pakistán',
      'Palaos',
      'Panamá',
      'Papúa Nueva Guinea',
      'Paraguay',
      'Perú',
      'Polonia',
      'Portugal',
      'Reino Unido',
      'República Centroafricana',
      'República Checa',
      'República del Congo',
      'República Dominicana',
      'República del Sudán',
      'Rumanía',
      'Rusia',
      'Rwanda',
      'Samoa',
      'San Cristóbal y Nieves',
      'San Marino',
      'San Vicente y las Granadinas',
      'Santo Tomé y Príncipe',
      'Senegal',
      'Serbia',
      'Seychelles',
      'Sierra Leona',
      'Singapur',
      'Eslovaquia',
      'Eslovenia',
      'Somalia',
      'Sudáfrica',
      'Sudán',
      'Suecia',
      'Suiza',
      'Siria',
      'Tailandia',
      'Tanzania',
      'Tayikistán',
      'Timor Oriental',
      'Togo',
      'Tonga',
      'Trinidad y Tobago',
      'Túnez',
      'Turkmenistán',
      'Turquía',
      'Tuvalu',
      'Uganda',
      'Ucrania',
      'Uruguay',
      'Uzbekistán',
      'Vanuatu',
      'Vaticano',
      'Venezuela',
      'Vietnam',
      'Yemen',
      'Zambia',
      'Zimbabue'
  ],
    



   /* colorDark500: '#212226',
    colorDark400: '#2A2B2D',
    colorDark300: '#303136',
    colorDark200: '#363940',
    colorDark100: '#40454B',

    colorLight500: '#FFFFFF',
    colorLight400: '#F2F3F5',
    colorLight300: '#E4E6E9',
    colorLight200: '#D1D4D9',
    colorLight100: '#51575F',

    colorFondo500: '#212226',
    colorFondo400: '#2A2B2D',
    colorFondo300: '#303136',
    colorFondo200: '#363940',
    colorFondo100: '#40454B',

    colorFront500: '#FFFFFF',
    colorFront400: '#F2F3F5',
    colorFront300: '#E4E6E9',
    colorFront200: '#D1D4D9',
    colorFront100: '#51575F',

    colorAccent1: '#17A85D',
    colorAccent2: '#012D5A',*/
    
   

   
  },

  mutations: {
    setLoading (state, bool){
      state.loading = bool
    },

    setDrawer (state, value){
      state.drawer = value;
    },

    setThemeVerdeOpacoMostaza(state, bool){
      state.colorFondo = state.colorFondoOscuro;
      state.colorFondoDialog = state.colorBlanco;
      state.colorAccent1 = state.colorMostazaClaro;
      state.colorAccent2 = state.colorMostazaOscuro;
      state.colorAccent3 = state.colorAzul;
      state.colorNavigationMenu = state.colorVerdeOpacoClaro;
      state.colorBarraFormulario = state.colorVerdeOpacoOscuro;
      state.colorBarraFormularioSecundario = state.colorVerdeOpacoClaro;
   },

    setThemePrimary(state, bool){
       state.colorFondo = state.colorGrisClaro;
       state.colorFondoDialog = state.colorBlanco;
       state.colorAccent1 = state.colorVerde3;
       state.colorNavigationMenu = state.colorAzul3;
    },

    setDark (state, bool){
      state.dark = bool;
      if (state.dark){
        state.colorFondo500 = state.colorDark500;
        state.colorFondo400 = state.colorDark400;
        state.colorFondo300 = state.colorDark300;
        state.colorFondo200 = state.colorDark200;
        state.colorFondo100 = state.colorDark100;

        state.colorFront500 = state.colorLight500;
        state.colorFront400 = state.colorLight400;
        state.colorFront300 = state.colorLight300;
        state.colorFront200 = state.colorLight200;
        state.colorFront100 = state.colorLight100;
      }else{
        state.colorFondo500 = state.colorLight500;
        state.colorFondo400 = state.colorLight400;
        state.colorFondo300 = state.colorLight300;
        state.colorFondo200 = state.colorLight200;
        state.colorFondo100 = state.colorLight100;

        state.colorFront500 = state.colorDark500;
        state.colorFront400 = state.colorDark400;
        state.colorFront300 = state.colorDark300;
        state.colorFront200 = state.colorDark200;
        state.colorFront100 = state.colorDark100;

      }
    }
  },
  actions: {
    


  },
  modules: {
    auth, reservas, clientes, 
    estados, reportes, mensajes, categorias, caminos, puntos, 
    proveedores, etapas, origenes, grupos, reglas, inventario,
    apicorreos
  }
})
